import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
const SvgIconFolder = (props) => (_jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", focusable: false, ...props, children: _jsx("path", { d: "M20 5h-8.586L9.707 3.293A.997.997 0 0 0 9 3H4c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2V7c0-1.103-.897-2-2-2zM4 19V7h16l.002 12H4z" }, void 0) }, void 0));
const Memo = memo(SvgIconFolder);
export default Memo;
//# sourceMappingURL=IconFolder.js.map